export const MY_AVAILABILITY_GET_REQUEST = "MY_AVAILABILITY_GET_REQUEST";
export const MY_AVAILABILITY_GET_SUCCESS = "MY_AVAILABILITY_GET_SUCCESS";
export const MY_AVAILABILITY_GET_FAIL = "MY_AVAILABILITY_GET_FAIL";
export const MEMBERSHIP_PLAN_GET_REQUEST = "MEMBERSHIP_PLAN_GET_REQUEST";
export const MEMBERSHIP_PLAN_GET_SUCCESS = "MEMBERSHIP_PLAN_GET_SUCCESS";
export const MEMBERSHIP_PLAN_GET_FAIL = "MEMBERSHIP_PLAN_GET_FAIL";
